import React from 'react';
import PropTypes from 'prop-types';
import { Container, Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import API from '../../../../actions/api';

import './GoogleOpeningHoursFetcher.scss';

const GoogleOpeningHoursFetcher = ({
    restId, placeId, updateSchedule
}) => {
    return (
        <Container fluid>
            <Button
                className="pi-google-opening-hours-fetcher"
                floated="right"
                icon='google'
                onClick={() => {
                    if (placeId) {
                        API.restaurant.get(restId).openingHours.fetchFromGoogle(placeId)
                            .then(({ data }) => {
                                updateSchedule(data);
                            }).catch(err => err);
                    }
                }}
            />
        </Container>
    );
};

GoogleOpeningHoursFetcher.propTypes = {
    restId: PropTypes.string,
    placeId: PropTypes.string,
    updateSchedule: PropTypes.func,
    
};

export default GoogleOpeningHoursFetcher;